export default "__VITE_ASSET__dff88bb0__"